import { render } from "./campaign-type.vue?vue&type=template&id=9d2fab46&ts=true"
import script from "./campaign-type.ts?vue&type=script&lang=ts&external"
export * from "./campaign-type.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__